import * as actionType from "../constants/actionTypes";

// const initialState = {
//     assigngroupidtoreport: [],
//     reportsid: {}
//   };

const authReducer = (state = { authData: null }, action) => {
  switch (action.type) {

    case actionType.ASSIGN_GROUP_ID_TO_REPORT:
      return { ...state, assignrespons: action.data.data, loading: false, error: null };

    case actionType.GET_REPORT_DETAIL_BASEON_GROUP_ID:
      return { ...state, getreportdetailonbasisofgroupId: action.data.data, loading: false, error: null };

    case actionType.GET_REPORT_DETAIL_BASEON_GROUP_ID_REPORTS:
      return { ...state, getreportdetailonbasisofgroupIdgroupid: action.data.data, loading: false, error: null };

    // case actionType.ASSIGN_GROUP_ID_FOR_REPORTING_CONSOLE:
    //   return {
    //     ...state, reportingConsoleAssignResponse: action.data.data,
    //     loading: false,
    //     error: null,
    //   };

    // case actionType.GET_REPORT_DETAIL_FOR_REPORTING_CONSOLE:
    //   return {
    //     ...state,
    //     reportingConsoleReports: action.data.data,
    //     loading: false,
    //     error: null,
    //   };



    default:
      return state;
  }
};



export default authReducer;